import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "@/components/common/inputs/Input";
import Button from "@/components/common/Button";
import { SearchOutlined } from "@/config/antd";

const ChatHome = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const tickets = [
    {
      id: 1,
      question:
        "Can I get my phone number linked with my account on the platform?",
      from: "Nusaiba Sabiu",
      time: "10 Mins Ago",
    },
    {
      id: 2,
      question: "How many customers can be added at once to a single account?",
      from: "Sergei Brin",
      time: "1 Hour ago",
    },
    {
      id: 3,
      question:
        "I've been trying to recover my password for over an hour now but the system is throwing an exception error. Please HELP!",
      from: "Angela Bridget",
      time: "7 Hours ago",
    },
    {
      id: 4,
      question:
        "Why is my account's invoices not showing full details of the customer?",
      from: "Fela Adekunle",
      time: "12 Hours ago",
    },
    {
      id: 5,
      question:
        "So our subscription is about to expire and we need something higher. Can you help us with switching?",
      from: "Mark Zuckerberg",
      time: "Yesterday",
    },
  ];

  return (
    <div className="w-full text-left">
      <div>
        <h1 className="text-medium font-semibold mb-2">
          Chat with Veegil Customers Support
        </h1>
        <p className="text-small text-lighterGrey mb-6">
          You can get immediate problems solved from our customer support team
          from here and as fast as you can.
        </p>

        {/* Search Input */}
        <div className="mb-6">
          <Input
            placeholder="Search for Help"
            icon={<SearchOutlined />}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="bg-gray-50"
          />
        </div>

        {/* Tickets List */}
        <div className="space-y-6">
          {tickets.map((ticket) => (
            <div
              key={ticket.id}
              className="border-l-4 border-primary pl-4 py-2 hover:bg-secondary cursor-pointer"
              onClick={() => navigate(`/chat/${ticket.id}`)}
            >
              <h3 className="text-regular mb-2">{ticket.question}</h3>
              <div className="flex justify-between text-sm text-gray-500">
                <span className="text-small">From {ticket.from}</span>
                <span className="text-small">{ticket.time}</span>
              </div>
            </div>
          ))}
        </div>

        {/* See All Messages Button */}
        <div className="mt-6 bg-secondary p-4 rounded-lg">
          <p className="text-small mb-4">
            Click below to view all customer tickets opened
          </p>
          <Button
            text="SEE ALL MESSAGES"
            color="primary"
            isActive={true}
            className="w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default ChatHome;
